import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import German from "flatpickr/dist/l10n/de.js";
import { FlatpickrDefaultsInterface, FlatpickrDirective } from "angularx-flatpickr";
import { getDateTime } from "../../funktionen/globale-funktionen";

@Component({
  selector: "love-it-date-range-picker",
  templateUrl: "./date-range-picker.component.html",
  styleUrls: ["./date-range-picker.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DateRangePickerComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class DateRangePickerComponent implements OnInit, ControlValueAccessor {
  @ViewChild(FlatpickrDirective) flatpickr: FlatpickrDirective;

  @Input() clearable = true;
  @Input() minDate: Date = null;
  @Input() maxDate: Date = null;
  @Input() readonly = false;

  changeFunction: any;
  setDateFormControl = new FormControl(null);

  public DateRangeOptions: FlatpickrDefaultsInterface;

  constructor() {}

  ngOnInit(): void {
    this.DateRangeOptions = {
      altInput: true,
      mode: "range",
      altInputClass: "form-control flat-picker flatpickr-input",
      altFormat: "d.m.y",
      locale: German.de,
      disableMobile: true,
      ...(this.minDate && { minDate: this.minDate }),
    };

    this.setDateFormControl.valueChanges.subscribe(() => {
      this.setDate(this.setDateFormControl.value?.split(" "));
    });
  }

  private setDate(splitDates: any[]) {
    if (splitDates && splitDates[0]) {
      this.changeFunction({
        from: getDateTime(splitDates[0]).setZone("Europe/Vienna").startOf("day").toJSDate(),
        to: getDateTime(splitDates[splitDates.length - 1])
          .setZone("Europe/Vienna")
          .endOf("day")
          .toJSDate(),
      });
    } else {
      this.changeFunction({ from: null, to: null });
    }
  }

  onOpen(dateObj, dateString, flatpickrInstance) {
    if (this.minDate) {
      flatpickrInstance.set("minDate", this.minDate);
    }
    if (this.maxDate) {
      flatpickrInstance.set("maxDate", this.maxDate);
    }
  }

  registerOnChange(fn: any): void {
    this.changeFunction = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any): void {
    if (value) {
      if (value.from !== this.setDateFormControl.value?.[0] || value.to !== this.setDateFormControl.value?.[1]) {
        this.setDateFormControl.setValue([value.from, value.to], { emitEvent: false });
      }
      if (
        value.from === null &&
        value.to === null &&
        this.setDateFormControl.value?.length === 2 &&
        this.setDateFormControl.value?.[0] === null &&
        this.setDateFormControl.value?.[1] === null
      ) {
        this.setDateFormControl.setValue([], { emitEvent: false });
      }
    } else {
      if (this.setDateFormControl.value?.length) {
        this.setDateFormControl.setValue([], { emitEvent: false });
      }
    }
  }

  clearInput() {
    this.setDateFormControl.setValue(null);
  }

  get isEmpty(): boolean {
    return !this.setDateFormControl.value?.length;
  }

  onClose(event: any) {
    if (event.selectedDates.length === 2) {
      this.setDate(event.selectedDates);
    } else {
      this.setDate([]);
      this.setDateFormControl.setValue([], { emitEvent: false });
    }
  }

  setDisabledState(isDisabled: boolean) {
    this.readonly = isDisabled;
  }
}
